export default __webpack_public_path__ + "static/media/edit.4859560d.svg";